import React from 'react';
import styled, { keyframes } from 'styled-components';

interface AnimatedBackgroundProps {
  className?: string;
}

const float = keyframes`
  0% {
    transform: translateY(0px) rotate(0deg);
    opacity: 0.8;
  }
  50% {
    transform: translateY(-20px) rotate(5deg);
    opacity: 1;
  }
  100% {
    transform: translateY(0px) rotate(0deg);
    opacity: 0.8;
  }
`;

const floatReverse = keyframes`
  0% {
    transform: translateY(0px) rotate(0deg);
    opacity: 0.8;
  }
  50% {
    transform: translateY(20px) rotate(-5deg);
    opacity: 1;
  }
  100% {
    transform: translateY(0px) rotate(0deg);
    opacity: 0.8;
  }
`;

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: 0;
  pointer-events: none;
`;

const AnimatedElement = styled.div`
  position: absolute;
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(124, 58, 237, 0.1) 0%, rgba(124, 58, 237, 0) 70%);
  border-radius: 50%;
  top: 10%;
  right: -100px;
  animation: ${float} 15s infinite ease-in-out;
`;

const AnimatedElement2 = styled.div`
  position: absolute;
  width: 250px;
  height: 250px;
  background: radial-gradient(circle, rgba(236, 72, 153, 0.08) 0%, rgba(236, 72, 153, 0) 70%);
  border-radius: 50%;
  bottom: 10%;
  left: -50px;
  animation: ${floatReverse} 12s infinite ease-in-out;
`;

const AnimatedElement3 = styled.div`
  position: absolute;
  width: 150px;
  height: 150px;
  background: radial-gradient(circle, rgba(124, 58, 237, 0.05) 0%, rgba(124, 58, 237, 0) 70%);
  border-radius: 50%;
  top: 40%;
  left: 10%;
  animation: ${float} 20s infinite ease-in-out;
`;

const AnimatedElement4 = styled.div`
  position: absolute;
  width: 100px;
  height: 100px;
  background: radial-gradient(circle, rgba(236, 72, 153, 0.06) 0%, rgba(236, 72, 153, 0) 70%);
  border-radius: 50%;
  bottom: 30%;
  right: 15%;
  animation: ${floatReverse} 18s infinite ease-in-out;
`;

const AnimatedBackground: React.FC<AnimatedBackgroundProps> = ({ className }) => {
  return (
    <Container className={className}>
      <AnimatedElement />
      <AnimatedElement2 />
      <AnimatedElement3 />
      <AnimatedElement4 />
    </Container>
  );
};

export default AnimatedBackground;
